var ApiUrl = "";
if (!import.meta.env.DEV) {
  let url =
    "." +
    window.location.hostname.split(".")[1] +
    "." +
    window.location.hostname.split(".")[2];
  if (url == ".lnhy988.com") {
    ApiUrl = "//tkingdomsjp-api.lnhy988.com";
  } else {
    ApiUrl = "//jp-rsvgw.rastargames.com";
  }
}

// var ApiUrl = '//jp-rsvgw.rastargames.com'

export const api = {
  // 初始化
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/common-api-init
  init: ApiUrl + "/apiv1/comm/init",
  // 获取服务器时间
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/get-server-time
  time: ApiUrl + "/apiv1/comm/server-time",
  // 发送短信
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/rsvgw-sms-send
  // info: ApiUrl + 'https://api.rastargame.com',
  // 获取文章列表
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.08.14.45.08
  articles: ApiUrl + "/apiv1/comm/articles/list",
  // 获取文章列表（含主栏目ID）
  articles2: ApiUrl + "/apiv1/comm/articles/sublist",
  // 文章详情
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.07.17.14.43.56
  details: ApiUrl + "/apiv1/comm/articles/info",
  // 获取栏目列表
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.08.14.44.41
  columns: ApiUrl + "/apiv1/comm/columns/list",
  // 获取栏目扩展字段
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.03.11.10.02.43
  additi: ApiUrl + "/apiv1/comm/additi/info",
  // 立即预约
  // http://dev-doc.rastargame.com/read/overseas-rsvgw-new/date-2024.06.12.17.33.14
  reserve: ApiUrl + "/rsvapiv1/comm/reserve/v2/do",
  // 获取玩家预约邀请码
  getInviteCode: ApiUrl + "/rsvapiv1/comm/hybrid/get-invite-code",
  //预约里程碑
  milestone: ApiUrl + "/rsvapiv1/comm/reserve/milestone",
  //根据ip获取区号
  areaCode: ApiUrl + "/apiv1/comm/hybrid/country-info",
  // 获取活动信息
  activityInfo: ApiUrl + "/rsvapiv1/comm/hybrid/event-info",
  // 获取预约礼包
  giftLog: ApiUrl + "/rsvapiv1/comm/reserve/v2/gift-log",
  // 预创盟
  // 预创盟用户信息
  getUserinfo: ApiUrl + "/rsvapiv1/custom/alliance/userinfo",
  // 创建联盟
  alliance: ApiUrl + "/rsvapiv1/custom/alliance/alliance",
  // 联盟列表
  allianceList: ApiUrl + "/rsvapiv1/custom/alliance/alliance_list",
  // 加入联盟
  joinAlliance: ApiUrl + "/rsvapiv1/custom/alliance/join-alliance",
  // 获取任务积分
  point: ApiUrl + "/rsvapiv1/custom/alliance/point",
  // 获取同盟邀请码
  allianceInviteCode: ApiUrl + "/rsvapiv1/custom/alliance/alliance-invite-code",
  // 同盟奖励
  allianceGift: ApiUrl + "/rsvapiv1/custom/alliance/alliance-gift",
  // 我的同盟
  myAlliance: ApiUrl + "/rsvapiv1/custom/alliance/info",
  // 新增抽奖接口地址
  // 完成任务获取抽奖次数（如果超过任务限制，多次达成不会添加抽奖次数）
  drawTask: ApiUrl + "/rsvapiv1/comm/luck-draw/flow-activity",
  // 玩家可用抽奖次数
  getDrawNum: ApiUrl + "/rsvapiv1/comm/luck-draw/get-draw-num",
  // 抽奖
  luckDrawDo: ApiUrl + "/rsvapiv1/comm/luck-draw/do",
  // 抽奖日志
  luckDrawGetLog: ApiUrl + "/rsvapiv1/comm/luck-draw/get-log",
  // 获取抽奖次数任务列表
  taskList: ApiUrl + "/rsvapiv1/comm/luck-draw/task-list",
  // 日本冒险岛新增接口
  // 获取用户星辉OPENID预约
  getUserOpenidReserve: ApiUrl + "/rsvapiv1/comm/reserve/v2/open-do",
  // 获取邀请奖励礼包
  getInviteReward: ApiUrl + "/rsvapiv1/comm/reserve/invite-reward",
  // 单手杀小游戏初始化
  miniGameInit: ApiUrl + "/rsvapiv1/custom/mini-game/init",
  // 击杀数据
  miniGameSaveData: ApiUrl + "/rsvapiv1/custom/mini-game/save-data",
  // 领取击杀礼包
  miniGameGetGift: ApiUrl + "/rsvapiv1/custom/mini-game/get-game",
  // 寻宝页
  // 寻宝活动-用户数据初始化
  treasureUserInit: ApiUrl + "/rsvapiv1/custom/treasure/init",
  // 口令兑换
  doTreasure: ApiUrl + "/rsvapiv1/custom/treasure/do-treasure",
  // 阶段礼包列表
  treasureGiftList: ApiUrl + "/rsvapiv1/custom/treasure/phase-gift",
  // 寻宝活动-阶段栏目列表
  treasureColumns: ApiUrl + "/rsvapiv1/custom/treasure/columns",
};
